import { render, staticRenderFns } from "./begin_embark.vue?vue&type=template&id=220d060e&scoped=true&"
import script from "./begin_embark.vue?vue&type=script&lang=js&"
export * from "./begin_embark.vue?vue&type=script&lang=js&"
import style0 from "./begin_embark.vue?vue&type=style&index=0&id=220d060e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d060e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('220d060e', component.options)
    } else {
      api.reload('220d060e', component.options)
    }
    module.hot.accept("./begin_embark.vue?vue&type=template&id=220d060e&scoped=true&", function () {
      api.rerender('220d060e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/seafarer_embark/begin_embark.vue"
export default component.exports